export const APP_LOCALSTORAGE_JWT = 'bc_jwt';
export const APP_LOCALSTORAGE_USER = 'bc_user';
